import { createBrowserRouter } from 'react-router';

import Layout from './components/Layout/Layout';
import Index from './pages/Index';
import Blocks from './pages/Blocks';
import Squiggles from './pages/Squiggles';
import Notfound from './pages/Notfound';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Index />
      </Layout>
    ),
  },
  {
    path: '/squiggles',
    element: (
      <Layout>
        <Squiggles />
      </Layout>
    ),
  },
  {
    path: '/blocks',
    element: (
      <Layout>
        <Blocks />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
]);

export default router;
